module.exports = __webpack_public_path__ + "img/3-3.c2fe76c2.svg";